import {Flex, Spinner} from '@chakra-ui/react';
import {Theme} from './Theme';

export const Loader = () => <Flex style={Theme.Loader}><Spinner size={'lg'} /></Flex>